import React from 'react';
import TableRow from './TableRow';

const TableBody = ({ payments }) => {
    const rows = payments.map(payment => <TableRow key={payment.id} {...payment} />);
    return <tbody>{rows}</tbody>;
};

export default TableBody;


// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/Payments/TableBody.js